import { defaultSiteLanguage } from '@/globalConsts';

export const PATIENT_IDENTIFIER =
	defaultSiteLanguage === 'en-gb' ? 'NHS Number' : 'Patient Identifier';

export const NHS_SELF_REG_TOOLTIP = 'Not available for self-registered patients';
